import * as React from "react";
import {SvgIconProps} from "@material-ui/core/SvgIcon";

interface AppMenu {
  label: string
  icon: React.ComponentType<SvgIconProps>
  dataTest?: string
  items: AppMenuItem[]
}

interface AppMenuItem {
  messageId: string,
  defaultMessage: string,
  onClick: (item: AppMenuItem) => void
  link?: string
  externalLink?: ExternalLink
  dataTest?: string
}

interface ExternalLink {
  link: string
  newWindow?: boolean
}

class AppItemBuilder {
  private thisItem: AppMenuItem = <any>{};
  private callback: () => AppbarMenuBuilder;

  constructor(callback: () => AppbarMenuBuilder, messageId: string, defaultMessage: string){
    this.callback = callback;
    this.thisItem.messageId = messageId;
    this.thisItem.defaultMessage = defaultMessage;
  }

  get(): AppMenuItem {
    return this.thisItem;
  }

  item(messageId: string, defaultMessage: string): AppItemBuilder {
    return this.callback().item(messageId, defaultMessage)
  }

  build(): AppMenu {
    return this.callback().build();
  }

  onClick(callback: (item: AppMenuItem) => void): AppItemBuilder {
    this.thisItem.onClick = callback;
    return this;
  }

  link(link: string): AppItemBuilder {
    this.thisItem.link = link;
    return this;
  }

  externalLink(link: string, newWindow: boolean = false): AppItemBuilder {
    this.thisItem.externalLink = { link, newWindow };
    return this;
  }
}

export class AppbarMenuBuilder {

  private currentBuilder: AppItemBuilder;
  private readonly menu: AppMenu;

  constructor(label: string, icon: React.ComponentType<SvgIconProps>, dataTest?: string) {
    this.menu = <any>{};
    this.menu.label = label;
    this.menu.icon = icon;
    this.menu.dataTest = dataTest;
    this.menu.items = [];
  }

  private finishItem(): AppbarMenuBuilder {
    this.menu.items.push(this.currentBuilder.get());
    return this;
  }

  item( messageId: string, defaultMessage: string ): AppItemBuilder{
    this.currentBuilder = new AppItemBuilder(this.finishItem.bind(this), messageId, defaultMessage);
    return this.currentBuilder;
  }

  build(): AppMenu {
    return this.menu
  }
}


// WEBPACK FOOTER //
// ../../src/Layout/AppbarMenuBuilder.ts